import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../Auth/Login';
import NewBooking from '../pages/NewBooking';
import BookingDetails from '../pages/BookingDetails';
import Accepted from '../pages/Accepted';
import Progress from '../pages/Progress';
import AddInvoice from '../pages/AddInvoice';
import Invoice from '../pages/Invoice';
import Completed from '../pages/Completed';
import AdminLogin from '../Admin/AdminLogin';
import ChatList from '../Admin/ChatList';
import Chat from '../Admin/Chat';
import Bookings from '../Admin/Bookings';
import Details from '../Admin/Details';
import Agents from '../Admin/Agents';
import AgentDetails from '../Admin/AgentDetails';
import AddAgent from '../Admin/AddAgent';
import SearchBooking from '../pages/SearchBooking';
import FeedbackList from '../Admin/FeedbackList';

export default function PageNavigation() {
	return (
		<Routes>
			<Route path="/" element={<Login />} />
			<Route path="/admin-login" element={<AdminLogin />} />
			<Route path="/chat-list" element={<ChatList />} />
			<Route path="/new-booking" element={<NewBooking />} />
			<Route
				path="/booking-details/:order_number"
				element={<BookingDetails />}
			/>
			<Route path="/feed-back" element={<FeedbackList />} />
			<Route path="/accepted" element={<Accepted />} />
			<Route path="/progress" element={<Progress />} />
			<Route path="/add-invoice/:order_number" element={<AddInvoice />} />
			<Route path="/chat/:guest_id" element={<Chat />} />
			<Route path="/invoices/:order_number" element={<Invoice />} />
			<Route path="/completed" element={<Completed />} />
			<Route path="/bookings" element={<Bookings />} />
			<Route path="/agents" element={<Agents />} />
			<Route path="/search" element={<SearchBooking />} />
			<Route path="/add-agent" element={<AddAgent />} />
			<Route path="/detail/:order_number" element={<Details />} />
			<Route path="/agent-detail/:id" element={<AgentDetails />} />
		</Routes>
	);
}
